<template>
  <div>
    <v-list>
      <v-list-item
        v-for="item in treeData"
        :key="item.name"
        variant="plain"
        rounded="x1"
        color="promary"
      >
        <span
          @click="toggleNode(item)"
          :style="{
            cursor: 'pointer',
            fontWeight: item.open ? 'bold' : 'normal',
          }"
        >
          {{ item.name }}
        </span>
        <v-list v-if="item.children && item.open">
          <tree-view :treeData="item.children"></tree-view>
        </v-list>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
export default {
  name: "TreeView",
  props: {
    treeData: {
      type: Array,
      required: true,
    },
  },
  methods: {
    toggleNode(item) {
      item.open = !item.open;
    },
  },
};
</script>
